import React from 'react';
import './styles.scss';

const AloStaticSnackbar = ({ message, type = 'error' }: AloStaticSnackbarProps) => {
  const iconClassName = type === 'info' ? 'alo-info-icon' : 'alo-alert-icon';
  const messageClassName = `static-snackbar-message body-small ml-m-sm${type === 'info' ? '' : ' semibold'}`;

  return (
    <div className={`static-snackbar static-snackbar--${type} d-flex justify-content-center p-m-sm`}>
      <div className="static-snackbar-content d-flex align-items-start">
        <span className={iconClassName}></span>
        <span className={messageClassName}>{message}</span>
      </div>
    </div>
  );
};

interface AloStaticSnackbarProps {
  message: string;
  type?: 'error' | 'info';
}

export default AloStaticSnackbar;
